import React, { useState, useEffect } from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { apiCall } from '../../utils/apiUtils';

const AdminAnalyticsTab = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await apiCall('/get-platform-stats', null, { method: 'GET' });
                setStats(response);
            } catch (err) {
                console.error('Failed to load platform stats:', err);
                setError('Failed to load platform stats.');
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    if (loading) {
        return (
            <div className="loader-container">
                <ThreeDots color="#00BFFF" height={40} width={40} />
            </div>
        );
    }

    if (error) {
        return <div className="admin-empty">{error}</div>;
    }

    const kpis = [
        { label: 'Total Users', value: stats?.totalUsers ?? '—' },
        { label: 'Total Blogs Generated', value: stats?.totalBlogs ?? '—' },
        { label: 'Active Users (30d)', value: stats?.activeUsersLast30Days ?? '—' },
        { label: 'Est. Revenue (USD)', value: stats?.estimatedRevenueUsd != null ? `$${stats.estimatedRevenueUsd.toFixed(2)}` : '—' },
    ];

    return (
        <div>
            <h2 className="admin-section-title">Platform Analytics</h2>
            <div className="admin-kpi-grid">
                {kpis.map((kpi) => (
                    <div key={kpi.label} className="admin-kpi-card">
                        <div className="admin-kpi-label">{kpi.label}</div>
                        <div className="admin-kpi-value">{kpi.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminAnalyticsTab;
